export default __webpack_public_path__ + "static/media/vr-truck-circle-red.c8b4d960.svg";